import axios from 'axios';
import authenticationService, { showSessionExpiredAlert } from '../services/authentication_service.js';
import { urls, commonConfigs } from '../../config';
import { getLocalAccessToken, getLocalRefreshToken, removeUser } from '../services/local_service.js';

const instance = axios.create({
  baseURL: urls.baseUrl, // Staging base URL
  headers: {
    'Content-Type': 'application/json',
    // ...commonConfigs.apiHeader, // Staging headers
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = getLocalAccessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

instance.interceptors.response.use(
  (res) => {
    if (res.data.status == 'success') {
      return res;
    } else {
      return Promise.reject('failure in status');
    }
  },
  async (err) => {
    const originalConfig = err.config;
    // console.log('error response:', err.response);
    // console.log('error config:', err.config);
    // console.log('original config retry:', !originalConfig._retry);
    // console.log('getLocalRefreshToken:', getLocalRefreshToken());
    if (err.response && err.response.status === 401) {
      const refreshToken = getLocalRefreshToken();
      if (refreshToken && !originalConfig._retry) {
        console.log('IS IN HERE NOW');
        originalConfig._retry = true;
        try {
          // throw new Error('Session expired'); // Simulate session expiration
          const result = await authenticationService.refreshAccessToken();

          if (result !== true) {
            throw result;
          }
          return instance(originalConfig);
        } catch (error) {
          if (showSessionExpiredAlert()) {
            removeUser();
            window.location.href = '/login/developer';
          }
          
          return Promise.reject(error);
        }
      } else {
        if (showSessionExpiredAlert()) {
          removeUser();
          window.location.href = '/login/developer';
        }

        return Promise.reject(err)
      }
    }

    return Promise.reject(err.response.data.result.message);
  },
);

export default instance;